var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 0.3125C15.0938 0.6875 15.0938 1.34375 14.6875 1.71875L6.6875 9.71875C6.3125 10.125 5.65625 10.125 5.28125 9.71875L1.28125 5.71875C0.875 5.34375 0.875 4.6875 1.28125 4.3125C1.65625 3.90625 2.3125 3.90625 2.6875 4.3125L6 7.59375L13.2812 0.3125C13.6562 -0.09375 14.3125 -0.09375 14.6875 0.3125Z",
    fill: "#B43A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.470759bf169aa4c28dc297c27e446b05.svg";
export { ForwardRef as ReactComponent };